import Papa from 'papaparse';
import type { Degree, DegreeData } from '@/app/types/interfaces';

export function parseDegreesCsv(csvText: string, { wrappedRequirements = true }: { wrappedRequirements?: boolean } = {}): Degree[] {
  const result = Papa.parse<Record<string, string>>(csvText, { header: true });
  return (result.data ?? [])
    .filter((row) => row && /^[1-9]\d*$/.test(String(row.ID ?? '').trim()) && /[\p{L}\p{N}]/u.test(String(row.Name ?? '')))
    .map((row) => {
      const id = parseInt(String(row.ID ?? '0'), 10) || 0;
      const name = String(row.Name ?? '').trim();
      let requirementsData: DegreeData['requirements'];
      try { requirementsData = row.requirements?.trim() ? JSON.parse(row.requirements) as DegreeData['requirements'] : []; } catch { requirementsData = []; }
      return {
        ID: id,
        Name: name,
        'Degree Code': String(row['Degree Code'] ?? '').trim(),
        'Start Term': String(row['Start Term'] ?? '').trim(),
        requirements: wrappedRequirements ? { program_title: name, requirements: requirementsData, conditions: [], info: { course_definitions: '', course_list_mappings: '' } } : requirementsData,
      } as Degree;
    });
}
